import React from 'react';
import { motion } from 'framer-motion';
import { StarIcon } from 'lucide-react';
import type { Testimonial } from '../data/testimonials';
type Props = {
  testimonial: Testimonial;
  delay?: number;
};
export function TestimonialCard({
  testimonial,
  delay = 0
}: Props) {
  return <motion.figure initial={{
    opacity: 0,
    y: 20
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-60px'
  }} transition={{
    duration: 0.5,
    delay
  }} className="flex flex-col rounded-2xl border border-white/10 bg-ink-2 p-5" data-id="element-156" data-mp="2p7g9druzygnj">
      <figcaption className="flex items-center gap-3" data-id="element-157" data-mp="2z7p9vhw0uo8q">
        <img src={testimonial.img} alt={testimonial.name} className="h-11 w-11 shrink-0 rounded-full object-cover ring-2 ring-gold/50" data-id="element-158" data-mp="346a9bf3g93w4" />
        <div className="min-w-0" data-id="element-159" data-mp="19rfzfh1wr583">
          <div className="flex flex-wrap items-center gap-x-2 gap-y-0.5" data-id="element-160" data-mp="19siqpq3579oj">
            <span className="text-sm font-bold text-white" data-id="element-161" data-mp="1drrnl3thbnob">{testimonial.name}</span>
            <span className="flex gap-0.5 text-gold" aria-label="5 out of 5 stars" data-id="element-162" data-mp="htco475j1pxj">
              {Array.from({
              length: 5
            }).map((_, k) => <StarIcon key={k} className="h-3.5 w-3.5 fill-current" data-id="element-163" data-mp="d0jf3730zvfn" data-mpi={k} />)}
            </span>
          </div>
          <div className="flex items-center gap-1.5 text-xs text-white/50" data-id="element-164" data-mp="80oq592t9fx8">
            <span data-id="element-165" data-mp="35rkmc4qpop3">📍 {testimonial.location}</span>
            <span className="text-sm leading-none" aria-hidden="true" data-id="element-166" data-mp="10s8flaq03q7o">
              {testimonial.flag}
            </span>
          </div>
        </div>
      </figcaption>
      <blockquote className="mt-4 flex-1 border-t border-white/10 pt-4 text-[15px] leading-relaxed text-white/80" data-id="element-167" data-mp="vqrfvij969so">
        “{testimonial.quote}”
      </blockquote>
    </motion.figure>;
}